export const LANGS = ["de", "en", "es", "fr"];
export const AUTONOMY_ACTIONS = [
  "message_clients", "appointment_reminders", "outlook_events",
  "weekly_plan_reminders", "post_drafts", "mail_replies", "auto_tasks",
];
export const AUTONOMY_LEVELS = ["confirm", "auto", "never"];
export const WORKFLOWS = [
  "daily_briefing", "weekly_summary", "weekly_plan_reminder", "birthday_greetings",
  "session_followup", "inactive_clients", "post_draft_on_theme",
  "appointment_confirmations", "mail_reply_drafts",
];
export const PRIORITIES = ["urgent", "important", "normal", "later"];
export const WEEKDAYS = [0, 1, 2, 3, 4, 5, 6];
